import request from '@/src/utils/request'

export const getHotelRoomTypeOptions = async (productId, params = {}) => {
  const query = {
    state: typeof params.state === 'number' ? params.state : 1,
  }

  return await request.get(`/admin/hotel/${productId}/room-types/options`, {
    params: query,
  })
}
